import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { PlayerEvent } from '../../../../../services/interfaces';
import type { MatchHeaderStoreState } from '../../../../../services/interfaces/match-header';
import { isNumber, translateEntity } from '../../../../../services/utils';
import { getPlayerServiceUrl } from '../../../match-unit/helpers';

type Props = {
  state: ObservableMap<MatchHeaderStoreState>['state'];
};

const formatCardTime = (time?: { minute?: number; injuryMinute?: number }): string => {
  if (!isNumber(time?.minute)) return '';
  return time.injuryMinute ? `${time.minute}'+${time.injuryMinute}` : `${time.minute}'`;
};

const renderCard = (card: PlayerEvent) => {
  return (
    <li>
      <span class="pk-match-header__cards--player-name">{translateEntity(card.player).shortName}</span>{' '}
      {formatCardTime(card?.time) && <span class="pk-match-header__cards--minutes">{formatCardTime(card?.time)}</span>}
    </li>
  );
};

const renderCardWithLink = (card: PlayerEvent, competitionId: string, playerServiceUrl: string) => {
  return (
    <li>
      <a
        class="pk-match-header__cards--player-link"
        href={getPlayerServiceUrl(playerServiceUrl, card.player.id, competitionId)}
      >
        <span class="pk-match-header__cards--player-name">{translateEntity(card.player).shortName}</span>{' '}
        {formatCardTime(card?.time) && (
          <span class="pk-match-header__cards--minutes">{formatCardTime(card?.time)}</span>
        )}
      </a>
    </li>
  );
};

const MatchRedCards = ({ state }: Props) => {
  const match = state.matchData;
  if (!match) return null;

  const disableLink: boolean = state.disablePlayerLink;
  const playerServiceUrl: string = state.playerServiceUrl;

  const awayTeam = match.awayTeam;
  const homeTeam = match.homeTeam;
  const redCards = match.playerEvents?.redCards;

  if (!redCards?.length) return null;

  const awayRedCards = redCards.filter((redCard) => redCard.teamId === awayTeam.id);
  const homeRedCards = redCards.filter((redCard) => redCard.teamId === homeTeam.id);

  return (
    <div class="pk-match-header__cards">
      <div class="pk-match-header__cards--home" part="home-red-cards">
        <ul class="pk-match-header__cards--list">
          {homeRedCards.map((card) => {
            if (!disableLink) return renderCardWithLink(card, match.competition.id, playerServiceUrl);
            return renderCard(card);
          })}
        </ul>
      </div>
      <pk-icon
        class="pk-match-header__cards--red-card-icon"
        color="support-04"
        name="football-card-single-card"
        title="red card"
      />
      <div class="pk-match-header__cards--away" part="away-red-cards">
        <ul class="pk-match-header__cards--list">
          {awayRedCards.map((card) => {
            if (!disableLink) return renderCardWithLink(card, match.competition.id, playerServiceUrl);
            return renderCard(card);
          })}
        </ul>
      </div>
    </div>
  );
};

export { MatchRedCards };
